import {
  ACCIONES_MAQUINA_VIRTUAL,
  ACCIONES_SISTEMA_OPERATIVO_INVITADO_MAQUINA_VIRTUAL,
} from '@siptel-web/common';
import React from 'react';
import {
  TICKETS_MODALS,
  TELEFONIA_MODALS,
  SMS_NG_MODALS,
  USERS_MODALS,
  MAQUINAS_VIRTUALES_MODALS,
} from 'src/utils/constants';
import { useModal } from '../../contexts/Modal';
import CambiarEstadoMaquinaVirtualModal from './maquinas-virtuales/CambiarEstadoMaquinaVirtualModal';
import CambiarEstadoSistemaOperativoInvitadoModal from './maquinas-virtuales/CambiarEstadoSistemaOperativoInvitadoModal';
import VerInformacionMaquinaVirtualModal from './maquinas-virtuales/VerInformacionMaquinaVirtualModal';
import HabilitarDeshabilitar from './telefonia/HabilitarDeshabilitar';
import AdjuntarArchivosModal from './tickets/AdjuntarArchivosModal';
import CerrarTicketModal from './tickets/CerrarTicketModal';
import CrearTicketModal from './tickets/CrearTicketModal';
import DescargarArchivosModal from './tickets/DescargarArchivosModal';
import ReabrirTicketModal from './tickets/ReabrirTicketModal';
import VerChatTicketModal from './tickets/VerChatTicketModal';
import VerInformacionTicketModal from './tickets/VerInformacionTicketModal';
import HabilitarDeshabilitarPausarCampana from './sms-ng/HabilitarDeshabilitarPausarCampana';
import PermisosUsuarios from './configuraciones/PermisosUsuarios';
import Contrasenia from './configuraciones/Contrasenia';
import HabilitarDeshabilitarUsuario from './configuraciones/HabilitarDeshabilitarUsuario';
import EditarUsuario from './configuraciones/EditarUsuario';
import ModificarEstadoAni from './telefonia/ModificarEstadoAni';
import BloquearNumero from './telefonia/BloquearNumero';

export function AppModal() {
  const [state, { closeModal }] = useModal();

  let modal;

  switch (state.variant) {
    case TICKETS_MODALS.VER_INFORMACION:
      modal = <VerInformacionTicketModal {...state} close={closeModal} />;
      break;
    case TICKETS_MODALS.VER_CHAT:
      modal = <VerChatTicketModal {...state} close={closeModal} />;
      break;
    case TICKETS_MODALS.DESCARGAR_ARCHIVOS:
      modal = <DescargarArchivosModal {...state} close={closeModal} />;
      break;
    case TICKETS_MODALS.ADJUNTAR_ARCHIVOS:
      modal = <AdjuntarArchivosModal {...state} close={closeModal} />;
      break;
    case TICKETS_MODALS.CERRAR_TICKET:
      modal = <CerrarTicketModal {...state} close={closeModal} />;
      break;
    case TICKETS_MODALS.REABRIR_TICKET:
      modal = <ReabrirTicketModal {...state} close={closeModal} />;
      break;
    case TICKETS_MODALS.CREAR_TICKET:
      modal = <CrearTicketModal {...state} close={closeModal} />;
      break;
    case MAQUINAS_VIRTUALES_MODALS.VER_INFORMACION:
      modal = (
        <VerInformacionMaquinaVirtualModal {...state} close={closeModal} />
      );
      break;
    case MAQUINAS_VIRTUALES_MODALS.ENCENDER:
      modal = (
        <CambiarEstadoMaquinaVirtualModal
          {...state}
          data={{ ...state.data, accion: ACCIONES_MAQUINA_VIRTUAL.ENCENDER }}
          close={closeModal}
        />
      );
      break;
    case MAQUINAS_VIRTUALES_MODALS.APAGAR:
      modal = (
        <CambiarEstadoMaquinaVirtualModal
          {...state}
          data={{ ...state.data, accion: ACCIONES_MAQUINA_VIRTUAL.APAGAR }}
          close={closeModal}
        />
      );
      break;
    case MAQUINAS_VIRTUALES_MODALS.RESTABLECER:
      modal = (
        <CambiarEstadoMaquinaVirtualModal
          {...state}
          data={{ ...state.data, accion: ACCIONES_MAQUINA_VIRTUAL.RESTABLECER }}
          close={closeModal}
        />
      );
      break;
    case MAQUINAS_VIRTUALES_MODALS.SUSPENDER:
      modal = (
        <CambiarEstadoMaquinaVirtualModal
          {...state}
          data={{ ...state.data, accion: ACCIONES_MAQUINA_VIRTUAL.SUSPENDER }}
          close={closeModal}
        />
      );
      break;
    case MAQUINAS_VIRTUALES_MODALS.APAGAR_SISTEMA_OPERATIVO_INVITADO:
      modal = (
        <CambiarEstadoSistemaOperativoInvitadoModal
          {...state}
          data={{
            ...state.data,
            accion: ACCIONES_SISTEMA_OPERATIVO_INVITADO_MAQUINA_VIRTUAL.APAGAR,
          }}
          close={closeModal}
        />
      );
      break;
    case MAQUINAS_VIRTUALES_MODALS.REINICIAR_SISTEMA_OPERATIVO_INVITADO:
      modal = (
        <CambiarEstadoSistemaOperativoInvitadoModal
          {...state}
          data={{
            ...state.data,
            accion:
              ACCIONES_SISTEMA_OPERATIVO_INVITADO_MAQUINA_VIRTUAL.REINICIAR,
          }}
          close={closeModal}
        />
      );
      break;
    case TELEFONIA_MODALS.HABILITAR_NUM_BLOQUEADOS:
      modal = (
        <HabilitarDeshabilitar
          {...state}
          flag={TELEFONIA_MODALS.HABILITAR_NUM_BLOQUEADOS}
          close={closeModal}
        />
      );
      break;
    case TELEFONIA_MODALS.DESHABILITAR_NUM_BLOQUEADOS:
      modal = (
        <HabilitarDeshabilitar
          {...state}
          flag={TELEFONIA_MODALS.DESHABILITAR_NUM_BLOQUEADOS}
          close={closeModal}
        />
      );
      break;
    case TELEFONIA_MODALS.BLOQUEAR_NUMERO:
      modal = <BloquearNumero {...state} close={closeModal} />;
      break;
    case TELEFONIA_MODALS.HABILITAR_ANI:
      modal = (
        <ModificarEstadoAni
          {...state}
          flag={TELEFONIA_MODALS.HABILITAR_ANI}
          close={closeModal}
        />
      );
      break;
    case TELEFONIA_MODALS.DESHABILITAR_ANI:
      modal = (
        <ModificarEstadoAni
          {...state}
          flag={TELEFONIA_MODALS.DESHABILITAR_ANI}
          close={closeModal}
        />
      );
      break;

    case SMS_NG_MODALS.HABILITAR_CAMPANA:
      modal = (
        <HabilitarDeshabilitarPausarCampana
          {...state}
          close={closeModal}
          flag={SMS_NG_MODALS.HABILITAR_CAMPANA}
        />
      );
      break;
    case SMS_NG_MODALS.DESHABILITAR_CAMPANA:
      modal = (
        <HabilitarDeshabilitarPausarCampana
          {...state}
          close={closeModal}
          flag={SMS_NG_MODALS.DESHABILITAR_CAMPANA}
        />
      );
      break;
    case SMS_NG_MODALS.PAUSAR_CAMPANA:
      modal = (
        <HabilitarDeshabilitarPausarCampana
          {...state}
          close={closeModal}
          flag={SMS_NG_MODALS.PAUSAR_CAMPANA}
        />
      );
      break;
    case USERS_MODALS.PERMISOS_USUARIOS:
      modal = <PermisosUsuarios {...state} close={closeModal} maxWidth="md" />;
      break;
    case USERS_MODALS.CONTRASENIA:
      modal = <Contrasenia {...state} close={closeModal} />;
      break;
    case USERS_MODALS.EDITAR:
      modal = <EditarUsuario {...state} close={closeModal} />;
      break;
    case USERS_MODALS.HABILITAR_USUARIO:
      modal = (
        <HabilitarDeshabilitarUsuario
          flag={USERS_MODALS.HABILITAR_USUARIO}
          {...state}
          close={closeModal}
        />
      );
      break;
    case USERS_MODALS.DESHABILITAR_USUARIO:
      modal = (
        <HabilitarDeshabilitarUsuario
          flag={USERS_MODALS.DESHABILITAR_USUARIO}
          {...state}
          close={closeModal}
        />
      );
      break;
    default:
      modal = null;
  }

  return modal;
}

export default AppModal;
